import useQuery from "../../../util/useQuery";
import { useEffect, useState } from "react";
import EbasvuruTenantservice from "../../../service/Ebasvuru/EbasvuruTenantService";
import Accountservice from "../../../service/Core/AccountService";
import { Box, Button, Grid, Paper, Typography } from "@mui/material";
import useGlobal from "../../../util/Global";
import CustLabel from "../../../components/CustLabel";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import ZamanTipiEnum from "../../../enum/Ebasvuru/ZamanTipiEnum";
import { custformat } from "../../../util/DateUtil";
import StorageUtils from "../../../ui/StorageUtils";
import AdayPage from "./AdayPage";
import { useDispatch, useSelector } from "react-redux";
import { useAppCookies } from "../../../util/useAppCookies";
import { ActionType } from "../../../store/ActionType";

const IlanDetay = () => {
    const full = useSelector(user => user.auth);
    const query = useQuery();
    const [ilan, setIlan] = useState(null);
    const [loading, setLoading] = useState(true);
    const { t } = useGlobal();
    const history = useHistory();
    const aday = StorageUtils.get("aday");
    const tenantKey = query.get('tenant');
    const { setUser } = useAppCookies();
    const dispatch = useDispatch();
    const [login, setLogin] = useState(null);

    const goTo = (props) => {
        history.push(`/${props.page}`);

        if (full?.loginType != "aday") {
            StorageUtils.add("aday",
                {
                    basvuruId: props.basvuruId,
                    iapId: props.iapId
                });

            history.push(`/${props.page}`);
        } else {

            full.basvuruId = props.basvuruId;
            full.iapId = props.iapId;

            full.user.basvuruId = props.basvuruId;
            full.user.iapId = props.iapId;

            const adayUser = {
                accessToken: full.token,
                token: full.token,
                loginType: "aday",
                tenantName: full.user.tenantName,
                tenantIcon: full.user.tenantIcon,
                masterToken: full.token,
                userId: full.user.userId,
                basvuruId: props.basvuruId,
                iapId: props.iapId,
                adSoyad: full.user?.adSoyad,
                tenantKey: full.tenantKey
            }

            setUser(adayUser);

            dispatch({
                type: ActionType.ADAY_LOGIN,
                token: full.token,
                loginType: "aday",
                tenantName: full.user.tenantName,
                tenantIcon: full.user.tenantIcon,
                masterToken: full.token,
                userId: full.user.userId,
                basvuruId: full.basvuruId,
                iapId: full.iapId,
                user: full.user,
                tenantKey: full.tenantKey
            });

            Promise.resolve().then(() => {
                history.push("/");
            });

        }
    }

    const fetchAdayLogin = async () => {
        if (tenantKey) {
            try {
                const res = await Accountservice.loginAsAday({ tenant: tenantKey });

                if (res && res.token) {
                    EbasvuruTenantservice.setToken(res.token);

                    setLogin((prev) => {
                        if (!prev || prev.token !== res.token) {
                            return res;
                        }
                        return prev;
                    });
                    StorageUtils.save("aday",
                        {
                            token: res.token,
                            tenantKey: tenantKey,
                            masterTenant: res.masterTenant
                        }
                    );
                }
            } catch (error) {
                console.error("Login failed:", error);
            }
        }
    };

    useEffect(() => {


        if (!full.user) {
            fetchAdayLogin();
        } else {
            setLogin(full.user);
        }


    }, []); // Runs only once on mount

    useEffect(() => {
        if (login) {
            EbasvuruTenantservice.setToken(login.token);
            setLoading(true);

            EbasvuruTenantservice.Projesi({ id: aday?.iapId })
                .then((res) => {
                    if (res?.isSuccess) {
                        setIlan(res.resultObject[0]);
                    }
                })
                .catch((err) => console.error("Failed to fetch project:", err))
                .finally(() => setLoading(false));
        }
    }, [aday?.iapId, login]);

    useEffect(() => {

    }, [ilan, login])



    return (
        <AdayPage isLoading={loading}>
            <div style={{ margin: "25px 50px" }}>
                <Grid container spacing={2} >
                    <Grid item xs={12} md={3}>
                        <CustLabel
                            labelKey={'col.isIlanDetay'}
                            variant="h6"
                            basecolor={{ color: "#031F30" }}
                            layout="row"
                        />
                        <Paper sx={{ p: 2, bgcolor: "whitesmoke", fontWeight: "bold" }}>
                            <Typography
                                variant="h4"
                                color="text.primary"
                            >
                                {ilan?.baslik}
                            </Typography>
                        </Paper>
                        <Box sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}>
                            <Button variant="contained"
                                onClick={() => goTo({ page: "adayTelefonOnayi", iapId: ilan.id, basvuruId: ilan.basvuruFormuId })}
                                sx={{ backgroundColor: "#5C3B90", width: "100%", p: "10px" }}>
                                {t('col.HemenBasvuru')}
                            </Button>
                        </Box>

                        <Paper sx={{ mt: 2, p: 2, border: "1px solid #80808024", borderRadius: 1 }}>
                            <CustLabel layout="column" variant="h6" labelSx={{ color: "text.secondary", mt: 2 }} labelKey="col.calismaSekli" value={ZamanTipiEnum[ilan?.zamanTipi]} />
                            <CustLabel layout="column" variant="h6" labelSx={{ color: "text.secondary", mt: 2 }} labelKey="col.ilanTarihi" value={custformat(ilan?.talepTarihi)} />
                            <CustLabel layout="column" variant="h6" labelSx={{ color: "text.secondary", mt: 2 }} labelKey="col.sonBasvuru" value={custformat(ilan?.basvuruBitisTarihi)} />
                            <CustLabel layout="column" variant="h6" labelSx={{ color: "text.secondary", mt: 2 }} labelKey="col.Pozisyon" value={ilan?.isAciklamasi} />
                            <CustLabel layout="column" variant="h6" labelSx={{ color: "text.secondary", mt: 2 }} labelKey="col.ilveilce" value={`${ilan?.sehirAdi} / ${ilan?.ilceAdi}`} />
                            <CustLabel layout="column" variant="h6" labelSx={{ color: "text.secondary", mt: 2 }} labelKey="col.ilanNo" value={ilan?.iapKodu} />
                        </Paper>

                    </Grid>
                    <Grid item xs={12} md={9}>
                        <Paper sx={{ p: 2, mt: 3, minHeight: "60vh" }}>
                            <Typography dangerouslySetInnerHTML={{ __html: ilan?.metin }} />
                        </Paper>

                    </Grid>
                </Grid>
            </div>

        </AdayPage >
    );
};

export default IlanDetay;
